<template>
  <div style="padding-top: 60px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <h4 class="header-title">添加银行卡</h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
        <!-- <a v-if="!$store.state.token" @click="$parent.goNav('/login')" class="header-action" id="login_btn" style="font-size: 12px">登录</a> -->
      </div>
    </div>
    <div class="mod-bankcard">
      <form id="form_card" method="post" style="">
        <div class="addcard-wrap clearfix">
          <ul class="mod-forms bgWhite p15 mt10">
            <li @click="changShow">
              <label style="background-image: url(/static/image/icon_withdraw1.png)">银行类型 :</label>
              <div class="form-ipt">
                <input type="text" v-model="cardInfo.bank" placeholder="请输入银行类型" class="txt-ipt js-bankcode" disabled />
              </div>
            </li>
            <li>
              <label style="background-image: url(/static/image/icon_withdraw1.png)">开户行 :</label>
              <div class="form-ipt">
                <input type="text" id="bankcategory" name="bankcategory" class="txt-ipt" v-model="cardInfo.bank_address" placeholder="请输入开户行" />
              </div>
            </li>
            <li>
              <label style="background-image: url(/static/image/icon_reg4.png)">卡号 :</label>
              <div class="form-ipt">
                <input type="text" id="account" name="account" maxlength="50" class="txt-ipt" v-model="cardInfo.bank_no" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="请输入卡号" />
              </div>
            </li>
            <li>
              <label style="background-image: url(/static/image/info_icon2.png)">姓名 :</label>
              <div class="form-ipt">
                <input type="text" name="card" id="card" v-model="cardInfo.bank_owner" autocomplete="new-accounts" placeholder="请输入持卡人姓名" maxlength="50" class="txt-ipt cardnum" />
              </div>
            </li>
            <li>
              <label style="background-image: url(/static/image/info_icon2.png)">支付密码 :</label>
              <div class="form-ipt">
                <input id="confirm_card" name="confirm_card" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')"
 class="txt-ipt cardnum" type="password" autocomplete="new-password" v-model="cardInfo.pay_pass" placeholder="请输入支付密码" />
              </div>
            </li>
          </ul>

          <div class="tips p15" style="font-size: 0.24rem">
            <h1>温馨提示：</h1>
            <p>请您在相关注单结算完成后稍微耐心等待10-15分钟后系统会自动校正有效流水。详细有效流水规则请查看各游戏平台【天天返水】详情，感谢您的支持与信任！</p>
            <p>未参加任何优惠活动存款需投注1倍有效流水(全额投注额)即可提款，如参加活动亲参考活动红利流水详细规则。【如提款未成功，请留意站内信历史消息详细说明】感谢您的支持与信任.</p>
          </div>

          <div class="p15 mtb15">
            <a class="confirm-sub" id="verify_btn2" href="javascript:void(0);" @click="bindCard">提交</a>
          </div>
        </div>
      </form>
    </div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="银行类型" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'addBankCard',
  data() {
    return {
      cardInfo: {},
      banklist: [],
      show: false,
    };
  },
  created() {
    let that = this;
    that.getBanklist();
  },
  methods: {
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.cardInfo.bank = value.bank_name;
      console.log(this.cardInfo.bank);
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    getBanklist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, '请输人银行卡号');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, '请输人正确的卡号长度');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输人支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
#form_card .addcard-wrap .mod-forms label {
  padding-left: 30px;
  background: no-repeat 10px 10px;
  background-size: 22px;
}
#form_card .addcard-wrap .mod-forms li .form-ipt .txt-ipt {
  width: 80%;
}
.select2-container--default .select2-selection--single {
  border: 0 !important;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 43px !important;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addBankCard.vue